<template>
    <div>
        <page-title-bar></page-title-bar>
        <v-container fluid grid-list-xl py-0>
            <app-card customClasses="mb-30 elevation-5">
                <v-form autocomplete="autocomplete_off_hack_xfr4!k">
                    <input autocomplete="autocomplete_off_hack_xfr4!k" name="hidden" type="text" style="display:none;">
                    <div class="subheading mb-3">Modifica utente</div>
                    <v-layout row wrap center>
                        <v-flex xs6>
                            <v-text-field required label="Nome" v-model="user.firstName"></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                            <v-text-field required label="Cognome" v-model="user.lastName"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap center>
                        <v-flex xs6>
                            <v-text-field required label="Username" v-model="user.signInName" :readonly="true"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap center>
                        <v-flex xs6>
                            <v-text-field required label="Modifica Password" type="password" v-model="user.password" readonly onfocus="this.removeAttribute('readonly');" onblur="this.setAttribute('readonly','');"></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                            <v-text-field required label="Conferma Modifica Password" type="password" v-model="user.confirmPassword" autocomplete="new-password"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-card-actions class="justify-center">
                        <v-layout row wrap center>
                            <v-flex xs12>
                                <div class="title text-xs-center" ref="errorMessage" v-if="errorMessage != ''">
                                    <span class="red--text" v-html="errorMessage"></span>
                                </div>
                            </v-flex>
                            <v-flex xs12>
                                <div class="text-xs-center">
                                    <v-btn center color="primary" large @click="onEditClick">Salva</v-btn>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </app-card>
        </v-container>
    </div>
</template>

<script>

    import api from "Api";

    export default {
        data() {
            return {
                errorMessage: "",
                user: {
                    id: 0,
                    firstName: '',
                    lastName: '',
                    signInName: '',
                    password: '',
                    confirmPassword: ''
                }
            };
        },

        mounted() {
            const instance = this;

            const id = instance.$route.params.id;

            api.instance.get(`users/${id}`)
                .then((res) => {
                    console.log(res);
                    instance.user = res.data;
                });
        },

        methods: {
            onEditClick() {
                const instance = this;

                api.instance.post(`users/${instance.user.id}`, instance.user)
                    .then((res) => {
                        if (res.data.success == false) {
                            instance.errorMessage = res.data.messages.join("<br>");
                        } else {
                            instance.$router.push("/users");
                        }
                    })
                    .catch(() => {
                        instance.errorMessage = "Si è verificato un errore";
                    });
            }
        }
    };

</script>